<div class="app-container">
    <app-header></app-header>
    <div class="app-content" [class.mobile]="isMobile">
        <div>
            <router-outlet></router-outlet>
        </div>
        <div class="help-panel" *ngIf="showHelpPanel$ | async">
            <app-help-side-panel [isMobile]="isMobile"></app-help-side-panel>
        </div>
    </div>
    <app-footer></app-footer>
    <app-cookies-consent></app-cookies-consent>
</div>
